import GLightbox from "glightbox";
import "glightbox/dist/css/glightbox.min.css";
import { accordionsFunc, mq, getMonthAbbreviation } from "./utils";

const calendarFunc = ($prefix) => {
  if (document.getElementById(`calendar-${$prefix}`) == null) return;

  let pageNum = 1;
  let holidays;
  let currentSlide;
  let currentTrigger;

  const calendarCreating = (json, today) => {
    const week = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
    // 月末だとずれる可能性があるため、1日固定で取得
    const showDate = new Date(today.getFullYear(), today.getMonth(), 1);

    // 前の月表示
    function prev() {
      showDate.setMonth(showDate.getMonth() - 1);
      pageNum--;
      showProcess(showDate);
    }

    // 次の月表示
    function next() {
      showDate.setMonth(showDate.getMonth() + 1);
      pageNum++;
      showProcess(showDate);
    }

    function monthCheck(num, year, month) {
      const eventData = json.cal[0][`${year}${month + 1}`];
      const nextData = json.cal[0][`${year}${month === 11 ? 0 : month + 2}`];

      if (eventData.length && num === 1) {
        document.getElementById(`prev-${$prefix}`).classList.add("disabled");
      } else if (num > 1) {
        document.getElementById(`prev-${$prefix}`).classList.remove("disabled");
      }

      if (!nextData?.length) {
        document.getElementById(`next-${$prefix}`).classList.add("disabled");
      } else {
        document.getElementById(`next-${$prefix}`).classList.remove("disabled");
      }
    }

    // カレンダー表示
    function showProcess(date) {
      const year = date.getFullYear();
      const month = date.getMonth();
      monthCheck(pageNum, year, month);

      const calendar = createProcess(year, month);
      document.querySelector(`#calendar-${$prefix}`).innerHTML = calendar;
      document.querySelector(`#calendar-${$prefix}-title`).innerHTML = `${year} <b class="fz-70">${month + 1}</b> ${getMonthAbbreviation(month + 1)}`;

      openModalFunc();
    }

    // カレンダー作成
    function createProcess(year, month) {
      let calendar = mq("pc")
        ? `<table class="event-calendar"><tr><th id="calendar-${$prefix}-title" class="title" colspan="7"></th></tr><tr class="dayOfWeek">`
        : `<table class="event-calendar" data-lenis-prevent><tr><th id="calendar-${$prefix}-title" class="title" colspan="7"></th></tr><tr class="dayOfWeek">`;

      for (let i = 0; i < week.length; i++) {
        calendar += `<th>${week[i]}</th>`;
      }
      calendar += "</tr>";

      let count = 0;
      const startDayOfWeek = new Date(year, month, 1).getDay();
      const endDate = new Date(year, month + 1, 0).getDate();
      const lastMonthEndDate = new Date(year, month, 0).getDate();
      const row = Math.ceil((startDayOfWeek + endDate) / week.length);
      const eventData = json.cal[0][`${year}${month + 1}`];
      const currentToday = new Date();

      for (let i = 0; i < row; i++) {
        calendar += "<tr>";
        for (let j = 0; j < week.length; j++) {
          if (i === 0 && j < startDayOfWeek) {
            // 前月の日付
            calendar += `<td class='disabled'>${lastMonthEndDate - startDayOfWeek + j + 1}</td>`;
          } else if (count >= endDate) {
            // 翌月の日付
            count++;
            calendar += `<td class='disabled'>${count - endDate}</td>`;
          } else {
            // 当月日付
            let value;
            for (const key in eventData[count]) {
              value = eventData[count][key];
            }
            count++;

            const pmonth = `0${month + 1}`.slice(-2);
            const pcount = ("0" + count).slice(-2);

            let holidayName = false;
            if (holidays[`${year}-${pmonth}-${pcount}`] !== undefined) {
              holidayName = holidays[`${year}-${pmonth}-${pcount}`];
            }

            const isToday = year === currentToday.getFullYear() && month === currentToday.getMonth() && count === currentToday.getDate();
            const hasEvent = value[0]?.event;
            const textContent = value[0]?.text ? value[0]?.text : "";
            const weekendClass = (j === 0 ? " sun" : "") + (j === 6 ? " sat" : "");
            const holidayClass = holidayName ? " holidays" : "";
            const dayCellClass = `${isToday ? "today" : ""}${weekendClass}${holidayClass} d${count}`;

            // イベントリンクまたはテキスト
            if (hasEvent) {
              calendar += `<td class="${dayCellClass}"><a href="#modal-${$prefix}" class="open noscroll glightbox" data-week="${week[j]}" data-month="${month}" data-day="${count}" data-event="${value[0]?.event}"><div class="day">${count}</div>${textContent ? `<span>${textContent}</span>` : ""}</a></td>`;
            } else {
              if (textContent === "キャンプ休日") {
                calendar += `<td class="${dayCellClass} off"><div class="day">${count}</div><span class="nocamp">キャンプ休日</span></td>`;
              } else {
                calendar += `<td class="pc ${dayCellClass}"><div class="day">${count}</div>${textContent ? `<span>${textContent}</span>` : ""}</td>`;
              }
            }
          }
        }
        calendar += "</tr>";
      }
      return calendar;
    }

    function openModalFunc() {
      // GLightboxの初期化
      const lightbox = GLightbox({
        selector: `.glightbox`,
        touchNavigation: false,
        loop: false,
        draggable: false,
        touchNavigation: false,
        keyboardNavigation: false,
        width: "1000px",
        height: mq("pc") ? "85%" : "80%",
        // onCloseはGLightboxが閉じた時に実行
        onClose: () => {
          setTimeout(() => {
            currentSlide = null;
            currentTrigger = null;
            console.log("classList.remove")
            document.querySelector("body").classList.remove("eventAll");
            // document.querySelectorAll(".event-box").forEach((e) => {
            //   e.className = "event-box";
            // });
          }, 100);
          document.documentElement.style.overflow = "auto";
        },
      });

      lightbox.on("open", (prop) => {
        document.documentElement.style.overflow = "hidden";
        // currentTriggerに格納されたクリックされた要素から情報を取得


      });





    }

    showProcess(today);

    document.addEventListener("click", (e) => {
      if (e.target.id === `next-${$prefix}`) {
        next();
      }
      if (e.target.id === `prev-${$prefix}`) {
        prev();
      }
    });
    document.addEventListener("click", (e) => {
      currentTrigger = e.target.closest(".glightbox");
      if (currentTrigger) {
        currentSlide = document.getElementById("glightbox-body").querySelector(".current");
        accordionsFunc(currentSlide);
        document.querySelector("body").classList.remove("eventAll");
        const eventMonth = Number(currentTrigger.dataset.month) + 1;
        const eventDay = currentTrigger.dataset.day;
        const eventClass = currentTrigger.dataset.event;
        const eventWeek = currentTrigger.dataset.week;

        if (eventClass) {
          // イベントがある場合
          eventClass.split(",").forEach((value) => {
            currentSlide.querySelector(`.${$prefix}-${value}`).classList.add("eventDisplay");
          });
          currentSlide.querySelector(`.event-modal-title`).innerHTML = `<span class="en2">${eventMonth}.${eventDay}<span class="ml-5 fz-14">${eventWeek}</span></span>`;
        } else {
          // イベントがない場合
          console.log($prefix);
          console.log("イベントがない場合");
          currentSlide.querySelector(`.event-modal-title`).innerText = `イベント一覧`;
          document.querySelector("body").classList.add("eventAll");
        }
      } else {
        // 念のため
        document.getElementById(`${$prefix}-event`).innerText = `イベント一覧`;
      }
    });

  };

  // jQueryのajaxをfetchに変更
  // 同期的な処理が必要だった部分は、fetch後のPromiseチェーンで実現
  fetch(`./json/holidays.json`)
    .then((response) => response.json())
    .then((json) => {
      holidays = json;
      return fetch(`./json/event-${$prefix}.json`);
    })
    .then((response) => response.json())
    .then((json) => {
      const removed = json.startCal.replace(/,/g, "/");
      const today = new Date(removed);
      calendarCreating(json, today);
    })
    .catch((error) => {
      console.error(error);
    });
};

export default calendarFunc;
